export const SET_CLASSES = 'setClasses'
export const SET_CLASS = 'setClass'
export const SET_PAGINATION = 'setPagination'
